import { useEffect, useCallback } from 'react';
import { useScript } from '@/hooks';
import { useAppDispatch, useAppSelector } from '@/redux';
import { addToast } from '@/redux/slices/toast.slice';
import { LoggerService } from '@/services';
import { LOG_URL, LOG_MSG } from '@/constants/logger';
import { URLS } from '@/constants/urls';

export const HipayFingerprint = ({ t, setFingerprint }) => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector(({ user }) => user.content?._id || '');
  const cartId = useAppSelector(({ cart }) => cart.content.id);
  const storeId = useAppSelector(({ root }) => root.storeConf.storeId);
  const fingerprint = useAppSelector(({ cart }) => cart.fingerprint);

  // The useScript is used to generate the customer fingerprint and filled the ioBB input with it
  const [loadedIoBB, ioBBError] = useScript(URLS.HIPAY_FINGERPRINT);

  const logMessage = useCallback((message: string, obj: any = undefined): void => {
    LoggerService.sendLog(cartId, message, storeId, LOG_URL.PAY, userId, obj);
  }, [cartId, storeId, userId]);

  useEffect(() => {
    if (ioBBError) {
      dispatch(addToast({ msg: t('checkout:payMode.loadPaymentError') }));
      logMessage(LOG_MSG.HIPAY.IOBB.ERROR, ioBBError);
    }
    if (loadedIoBB) {
      logMessage(LOG_MSG.HIPAY.IOBB.LOADED);
    }
  }, [loadedIoBB, ioBBError]);

  const ioBB = useCallback((node) => {
    if (node && node.value && node.value !== fingerprint) {
      logMessage(LOG_MSG.HIPAY.FINGERPRINT);
      setFingerprint(node.value);
    }
  }, [fingerprint]);

  return (
    <input type="text" ref={ioBB} id="ioBB" className="tu-ioBB" style={{ display: 'none' }} />
  );
};

export default HipayFingerprint;
